// test1557
(1557 && 0);
